"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _formatName = require("./formatName");
Object.keys(_formatName).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _formatName[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _formatName[key];
    }
  });
});
var _formatLinkTitle = require("./formatLinkTitle");
Object.keys(_formatLinkTitle).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _formatLinkTitle[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _formatLinkTitle[key];
    }
  });
});
var _formatMinPrice = require("./formatMinPrice");
Object.keys(_formatMinPrice).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _formatMinPrice[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _formatMinPrice[key];
    }
  });
});